import React from 'react';
import { useTranslation } from 'react-i18next';
import SolidButton from '@wix/da-ds/pkg/Buttons/SolidButton';
const NullIcon = ()=>/*#__PURE__*/ React.createElement("span", {
        style: {
            display: 'block',
            width: '1px',
            height: '24px'
        }
    });
const DummySubscribedVariant = ({ className , size ='medium' , href , onClick  })=>{
    const { t  } = useTranslation();
    return /*#__PURE__*/ React.createElement(SolidButton, {
        className: className,
        size: size,
        variant: 'approval-green',
        priority: "secondary",
        href: href,
        icon: NullIcon,
        onClick: onClick
    }, t('deviation.tier.subscribed'));
};
DummySubscribedVariant.displayName = 'DummySubscribedVariant';
export default DummySubscribedVariant;
